import { Box, Button, List, ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { CancelButton, ConfirmButton, PopupButton } from '../../../styles/buttonStyles';

type AccSettingsListProps = {
  isMobile: boolean;
};

export const AccSettingsList = styled(List)<AccSettingsListProps>(({ isMobile }) => ({
  overflow: isMobile ? 'auto' : null,
  padding: '0px 10px',
  '& > *': {
    marginTop: '17px',
  },
}));

export const PurpleButton = styled(Button)({
  color: '#7e87fc',
  '&:hover': {
    color: '#515cfb',
  },
  width: '220px',
  paddingLeft: '5px',
  paddingRight: '5px',
});

export const CenterListItem = styled(ListItem)({
  display: 'flex',
  justifyContent: 'center',
});

export const SaveButton = styled(ConfirmButton)(({ theme }) => ({
  [theme.breakpoints.down(420)]: {
    paddingLeft: '10px',
    paddingRight: '10px',
  },
}));

export const AccountCancelButton = styled(CancelButton)(({ theme }) => ({
  [theme.breakpoints.down(420)]: {
    paddingLeft: '10px',
    paddingRight: '10px',
  },
}));

export const AccountConfirmButton = styled(PopupButton)(({ theme }) => ({
  width: '150px',
  [theme.breakpoints.down('sm')]: {
    width: '100px',
  },
}));

export const PasswordRulesGrid = styled(Box)(({ theme }) => ({
  color: theme.palette.error.main,
  '&>p': {
    fontSize: '14px',
  },
  '&>p:first-child': {
    fontWeight: 'bold',
  },
}));

export const RevokeIcon = styled(PersonRemoveIcon)({
  cursor: 'pointer',
});

export const ChangeInfoButton = styled(Button)({
  width: '220px',
});
